

import { useQuery } from "@apollo/client";
import { GET_SAMPLE_SCHEDULE_REPORT } from "../../queries/publicQrys/WaterSystemReportQrys";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const SampleScheduleReport = () => {
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_SAMPLE_SCHEDULE_REPORT);

  useEffect(() => {
    if (loading || error || !data) return;
    const reportObj = data.getSampleScheduleReportCsv;
    if (!reportObj) return;
    const csvFileStream = reportObj.stream.replace(/\r?\n/g, '\r\n');
    const csvFileName = reportObj.filename;
    const blob = new Blob([csvFileStream], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = csvFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    history.replace('/');
    
  }, [loading, error, data, history]);

  return null;
};

export default SampleScheduleReport;